import React from "react";

import styled from "styled-components";

import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { prefixNumberFilter } from "app/filters/ngFilters";

export const RightAlignedCell = styled.div<{ rightPadding?: string | number }>`
    text-align: right;
    padding-right: ${(props) => (props.rightPadding ? props.rightPadding : "12px")};
`;

interface RankCellProps {
    format?: string;
    rightPadding?: string | number;
    undefinedSign?: string;
    value: number;
}

export class RankCell extends React.Component<RankCellProps> {
    private prefixNumber: any;
    private dynamicFilter: any;

    constructor(props: RankCellProps) {
        super(props);
        this.prefixNumber = prefixNumberFilter();
        this.dynamicFilter = dynamicFilterFilter();
    }

    public static defaultProps = {
        format: "number",
        undefinedSign: "-",
    };

    public render() {
        const { format, value, rightPadding, undefinedSign } = this.props;
        return (
            <RightAlignedCell
                className="cell-innerText"
                title={value < 1 ? "" : "#" + value}
                rightPadding={rightPadding}
            >
                {this.prefixNumber(this.dynamicFilter(value, format, undefinedSign), "#")}
            </RightAlignedCell>
        );
    }
}
